import { Component, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { API, DateTimeRangeDTO, DeviceFullDTO, ScreenFullDTO, SharedSetlistDTO } from '../../services/api/api';
import { ErrorService } from '../../services/error.service';
import { SelectDetailsResult, SelectDetailsValue } from '../../services/gui/modal/modal.model';
import { ModalService } from '../../services/gui/modal/modal.service';
import { UtilService } from '../../services/util.service';
import { SbDateTimeRangeViewerComponent } from '../controls/sb-date-time-range-viewer/sb-date-time-range-viewer.component';
import { TagService } from '../../services/tag.service';
import { DiscussionService } from '../../services/discussion.service';
import { RoutingID } from '../../routes/sb-routing-enum';
import { NavigationService } from '@ngx-seatback/utils';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'sb-comp-setlist-view',
  templateUrl: './sb-setlist-view.component.html',
  styleUrls: ['./sb-setlist-view.component.scss'],
  standalone: false,
})
export class SbSetlistViewComponent {
  @ViewChild('e') e: NgbCarousel;
  _sharedSetlists: SharedSetlistDTO[];

  @Input() isInDeviceContext: boolean = false;
  @Input() set sharedSetlists(val: SharedSetlistDTO[]) {
    this._sharedSetlists = val;
    this.currentSetlist = '1';
    if (this.e) {
      this.e.select(this.currentSetlist);
    }
  }

  get sharedSetlists(): SharedSetlistDTO[] {
    return this._sharedSetlists;
  }

  currentSetlist: string;
  displayedBooking: boolean[];

  constructor(
    private api: API,
    private modal: ModalService,
    public errorHandler: ErrorService,
    public util: UtilService,
    public translate: TranslateService,
    public tagService: TagService,
    public discussionService: DiscussionService,
    private navService: NavigationService,
    public permissionService: PermissionService
  ) {
    this.displayedBooking = [];
    this._sharedSetlists = [];
    this.currentSetlist = '1';
  }

  showDateTimeRanges(ranges: DateTimeRangeDTO[]) {
    this.modal
      .showNavigationModal({
        entryComponent: { value: SbDateTimeRangeViewerComponent, data: { dateTimeRanges: ranges } },
        title: null,
        modalOptions: { size: 'lg' },
      })
      .then(() => {})
      .catch(() => {});
  }

  showScreensModal(screens: ScreenFullDTO[]) {
    if (this.isInDeviceContext) {
      return;
    }
    const values: SelectDetailsValue<number>[] = [];

    for (const screen of screens) {
      values.push({
        name: this.translate.instant('lang.globals.device') + ' ' + screen.device.id,
        value: screen.device.id,
        description: this.translate.instant('lang.globals.screen') + ' ' + +screen.id,
      });
    }

    this.modal
      .selectWithDetails({
        values,
        initialValue: null,
        yes: this.translate.instant('lang.globals.showDevice'),
        no: this.translate.instant('lang.globals.cancel'),
        message: '',
        title: this.translate.instant('lang.globals.screens'),
        modalOptions: { size: 'xl' },
      })
      .then((e: SelectDetailsResult<number>) => {
        if (e?.value) {
          this.navService.resolvePoint(RoutingID.deviceDetails, [{ id: 'deviceID', value: e.value.value }]).then(data => {
            window.open('https://' + window.location.host + data, '_blank');
          });
        }
      });
  }
}
